import React from 'react'
import { useSubscription, usePlan } from 'commons/useSubscription'
import { PlanId, hasPlanEnded } from 'commons/plan'
import { Routes } from 'app/services/routeService/routeService'
import * as R from 'ramda'
import { FormattedMessage } from 'react-intl'
import { useIsAuthorized } from 'app/auth/authHooks'
import { WarningContainer } from 'app/components/WarningEndPlan'
import { useSelector } from 'react-redux'
import { path } from 'ramda'

function WarningPending(props) {
  const isCurrentPathRedemptionPath = R.compose(
    R.includes(Routes.redemptionBase()),
    R.defaultTo(''),
    R.path(['location', 'pathname']),
  )(props)
  const subscription = useSubscription()
  const plan = usePlan()

  const isAuthorized = useIsAuthorized()

  const pendingApproval = useSelector(
    path(['place', 'info', 'pendingApproval']),
  )
  if (
    (!isAuthorized ||
      !R.equals(PlanId.FREE_TRIAL, plan && plan.id) ||
      isCurrentPathRedemptionPath) &&
    !pendingApproval
  ) {
    return null
  }

  if (hasPlanEnded({ subscription }) && !pendingApproval) {
    return null
  }

  if (pendingApproval) {
    return (
      <WarningContainer icon="warning">
        <FormattedMessage id="app.header.pending.label"></FormattedMessage>
      </WarningContainer>
    )
  }
  return null
}

export default WarningPending
